module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ex-wrapper"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("Form Radio")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("All Information about Form Radio.")]), _vm._v(" "), _c('div', {
    staticClass: "example-set"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 example"
  }, [_c('div', {
    staticClass: "radio-group"
  }, [_c('input', {
    staticClass: "radio-true",
    attrs: {
      "type": "radio",
      "id": "rdo1",
      "value": "1",
      "name": "selector1"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-fake",
    attrs: {
      "for": "rdo1"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label",
    attrs: {
      "for": "rdo1"
    }
  }, [_vm._v("Label 1")])]), _vm._v(" "), _c('div', {
    staticClass: "radio-group"
  }, [_c('input', {
    staticClass: "radio-true",
    attrs: {
      "type": "radio",
      "id": "rdo2",
      "value": "2",
      "name": "selector1"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-fake",
    attrs: {
      "for": "rdo2"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label",
    attrs: {
      "for": "rdo2"
    }
  }, [_vm._v("Label 2")])]), _vm._v(" "), _c('div', {
    staticClass: "radio-group"
  }, [_c('input', {
    staticClass: "radio-true",
    attrs: {
      "type": "radio",
      "id": "rdo3",
      "value": "3",
      "name": "selector1"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-fake",
    attrs: {
      "for": "rdo3"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label",
    attrs: {
      "for": "rdo3"
    }
  }, [_vm._v("Label 3")])]), _vm._v(" "), _c('div', {
    staticClass: "radio-group"
  }, [_c('input', {
    staticClass: "radio-true",
    attrs: {
      "type": "radio",
      "id": "rdo4",
      "value": "4",
      "name": "selector2",
      "disabled": "disabled"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-fake",
    attrs: {
      "for": "rdo4"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label",
    attrs: {
      "for": "rdo4"
    }
  }, [_vm._v("Label 1 Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "radio-group"
  }, [_c('input', {
    staticClass: "radio-true",
    attrs: {
      "type": "radio",
      "id": "rdo5",
      "value": "5",
      "name": "selector2",
      "disabled": "disabled",
      "checked": "checked"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-fake",
    attrs: {
      "for": "rdo5"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label",
    attrs: {
      "for": "rdo5"
    }
  }, [_vm._v("Label 2 Disable")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 spacing"
  }, [_vm._v(" ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b69f2d84!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/styleGuide/ex-radio.vue
// module id = 3959
// module chunks = 1